<!-- //ANCHOR[epic=Quik Lookup] Entity Lookup
@
&#64;
{
&#123;
}
&#125;
-->
<!-- //FIXME[epic=tnk-Make Work,seq=2] chevron-toggle -->
<!-- //ANCHOR - Why? entitles for symbols @ { }
-->
<div class="flex flex-none items-center justify-end">
  @if (isOpen()) {
  <ism-svg [name]="'chevronDown'" [classString]="classString()"></ism-svg>
  }
  @else {
  <ism-svg [name]="'chevronRight'" [classString]="classString()"></ism-svg>
  }
</div>
